import { NgModule } from '@angular/core';
import { BpButtonDirective } from './button.directive';

@NgModule({
  declarations: [
    BpButtonDirective,
  ],
  exports: [
    BpButtonDirective,
  ]
})
export class BpButtonModule { }
